import { UrlConstants } from "../url.constants";
export class ApiBuildingPlansInspectorateConstants {
    static URL = UrlConstants.API_V2 + "BuildingPlansInspectorate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetBuildingPlansInspectorateApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateBuildingPlansInspectorateInvoiceReport";
    static FUNCTION_SET_PROPERTIES = "SetBuildingPlansInspectorateProperties";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetBuildingPlansInspectorateRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_VERIFY_BPI_BPAMS_REFERENCE_NUMBER = "VerifyBpiBpamsReferenceNumber";
    static FUNCTION_GET_MY_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS = "GetMyAFLAPortalBuildingPlansInspectorateApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_BUILDING_PLANS_APPLICATIONS = "GetAllAFLAPortalBuildingPlansInspectorateApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalBuildingPlansInspectorateApplication";
    static SAVE_LINKED_APPLICATION = "SaveLinkedApplication";
}
